import { Skeleton } from "@mui/material";
import useTitanApp from "@/hooks/useTitanApp";

export default function EmailSMSSettingsSkeleton() {
  const { appState } = useTitanApp();
  const { darkMode } = appState;
  const isDarkMode = darkMode;

  const skeletonSx = { bgcolor: isDarkMode ? "grey.800" : "", height: 40 };

  const mockEmailSMSTemplates = Array(6).fill(null);

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <Skeleton
          animation="wave"
          variant="text"
          width={180}
          height={32}
          sx={skeletonSx}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={140}
          height={36}
          className="rounded"
          sx={skeletonSx}
        />
      </div>

      {/* Member Cards */}
      <div className="space-y-4">
        {mockEmailSMSTemplates.map((_, index) => (
          <div
            key={index}
            className={`border rounded-lg p-4 ${
              isDarkMode
                ? "border-gray-700 bg-gray-800"
                : "border-gray-200 bg-white"
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="space-y-2">
                  {/* Name */}
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={160}
                    height={20}
                    sx={skeletonSx}
                  />
                  {/* Email */}
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={200}
                    height={16}
                    sx={skeletonSx}
                  />
                  {/* Clinician Badge */}
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width={300}
                    height={20}
                    className="rounded"
                    sx={skeletonSx}
                  />
                </div>
              </div>
              <div className="flex items-center gap-3">
                {/* Edit/Delete Buttons */}
                <div className="flex items-center gap-2">
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={28}
                    height={28}
                    sx={skeletonSx}
                  />
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={28}
                    height={28}
                    sx={skeletonSx}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
